module.exports = __webpack_public_path__ + "static/img/4.83296a9e.jpg";